<template>
  <div class="top-item" v-if="data.length">
    <img
      class="title-image"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/364f114233944036ae55c0015a41385f.png"
      alt=""
    />
    <div class="item-padding">
      <!-- <div class="toggle-open iconfont icon-black" :class="{ 'open-roate': isOpen }" @click="bindToggleOpen">
            </div> -->
      <div class="task-container">
        <div class="desc">*完成以下任一打卡，即算打卡成功</div>
        <div class="task-list">
          <div class="task-item" v-for="(item1, index1) in data" :key="index1">
            <img :src="item1.icon" class="item-icon" alt="" />
            <div class="item-center">
              <div
                ><span class="item-title">{{ item1.name }}</span>
              </div>
              <div class="item-desc">{{ item1.notice }}</div>
            </div>
            <div
              class="item-btn"
              :class="{
                'item-btn-confirm': item1.plan_state || [1, 2].includes(status)
              }"
              @click="bindClickItem(item1)"
              v-clickBuried
              data-click-buried="CLICK_VIP_HD_0YDK_DK"
              >{{ getBtnText(item1) }}</div
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    status: {
      type: Number,
      default: 0
    }
  },
  filters: {},
  computed: {},
  data() {
    return {
      isOpen: false
    }
  },
  methods: {
    bindToggleOpen() {
      this.isOpen = !this.isOpen
    },
    bindClickItem(item) {
      this.$emit('task', item)
    },
    getBtnText(item) {
      if (this.status == 1) {
        return '挑战成功'
      } else if (this.status == 2) {
        return '挑战失败'
      } else {
        return item.plan_state ? '已完成' : item.button_content
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.top-item {
  position: relative;
  border-style: solid;
  border-left-width: 0;
  border-right-width: 0;
  border-top-width: 20px;
  border-bottom-width: 20px;
  border-image-source: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/33c32071d346077825362b29fdf00ae6.png');
  border-image-slice: 60 0 60 0 fill;
  border-image-width: 20px 0 20px 10;
  margin-bottom: 46px;

  .title-image {
    position: absolute;
    left: 50%;
    top: -20px;
    transform: translate(-50%, -50%);
    width: 214px;
    height: 47px;
  }

  .item-padding {
    border-radius: 0px 0px 16px 16px;
    padding: 8px 16px 30px;

    .toggle-open {
      transition: transform 0.3s ease;
      position: absolute;
      left: 50%;
      bottom: 10px;
      width: 16px;
      height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      transform: translate(-50%, 0%) rotate(0deg);
      color: rgba(0, 0, 0, 0.3);
      font-size: 20px;
      transform-origin: center center;
    }

    .open-roate {
      transform: translate(-50%, 0%) rotate(180deg);
    }
  }

  .task-container {
    overflow: hidden;
    padding-top: 2px;

    .desc {
      text-align: center;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.5);
      line-height: 18px;
      margin-bottom: 26px;
    }

    .task-info {
      height: 18px;
      font-size: 13px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);
      line-height: 18px;
      margin-bottom: 26px;

      .red {
        color: #ff4444;
      }
    }

    .task-list {
      .task-item {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        .item-icon {
          width: 44px;
          height: 44px;
          object-fit: contain;
          margin-right: 10px;
        }

        .item-center {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
          margin-right: 10px;
        }

        .item-title {
          font-size: 15px;
          font-family: PingFangSC, PingFang SC;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.8);
          line-height: 24px;
          margin-right: 5px;
        }

        .item-num-icon {
          display: inline-block;
          width: 11px;
          height: 11px;
          object-fit: contain;
          margin-right: 3px;
        }

        .item-num {
          font-size: 16px;
          font-family: PingFangSC, PingFang SC;
          font-weight: bold;
          color: #ff6464;
          line-height: 22px;
        }

        .item-desc {
          font-size: 11px;
          font-family: PingFangSC, PingFang SC;
          color: rgba(0, 0, 0, 0.5);
          line-height: 18px;
        }

        .item-btn {
          width: 66px;
          height: 28px;
          background: #fc037a;
          border-radius: 15px;
          font-size: 12px;
          font-family: PingFangSC, PingFang SC;
          font-weight: bold;
          color: #ffffff;
          line-height: 28px;
          text-align: center;
        }

        .item-btn-confirm {
          background-color: rgba(252, 3, 122, 0.1);
          color: #fc037a;
        }
      }

      .task-item:last-child {
        margin-bottom: 0;
      }
    }
  }

  .task-container-limit {
    max-height: 494px;
  }
}
</style>
